/*
 * @Description: 全局注册自定义组件
 * @Date: 2021-03-22 00:52:55
 */
import { App } from 'vue';

// import { XrkTable } from '@xrk/table/index';
// import { BaseTab as XrkTab } from '@/components/base/tab';
// import { BaseSearch as XrkSearch } from '@/components/base/search';
import { BaseSvg } from '@/components/base/base-svg';
export function setupGlobalComponents(_app: App) {
  // app.component(XrkTable.name, XrkTable);
  // app.component('BaseTab', XrkTab);
  // app.component('BaseSearch', XrkSearch);
  _app.component('base-svg', BaseSvg);
}
